import { updateOptionsSelect2 } from '../helpers/helper.js';

const initInternalTrainingForm = () => {
	if(!$('#internal-training-add-edit-container').length){
		return;
	}

	const trainingGoal = $('#training_goal');
	const trainingGoalOther = $('#training_goal_other');
	const trainingType = $('#training_type');
	const trainingTypeOther = $('#training_type_other');
	const trainerField = $('#trainer_id');
	let roleField = $('#training_role');
	if(!roleField.length){
		roleField = $('[name="training_role"]');
	}
	let documentField = $('#training_document_ids');
	if(!documentField.length){
		documentField = $('[name="training_document_ids[]"]');
	}

	const toggleGroup = (field, show) => {
		if(!field.length){
			return;
		}
		const group = field.closest('.form-group');
		if(show){
			group.removeClass('d-none');
		}else{
			group.addClass('d-none');
		}
	};

	const toggleGoalOther = () => {
		toggleGroup(trainingGoalOther, trainingGoal.val() === 'other');
	};

	const toggleTypeOther = () => {
		toggleGroup(trainingTypeOther, trainingType.val() === 'other');
	};

	const toggleTrainer = () => {
		toggleGroup(trainerField, trainingType.val() === 'trainer');
	};

	const initTrainingEditor = () => {
		if(!window.ClassicEditor){
			return;
		}
		document.querySelectorAll('.ckeditor-training').forEach((element) => {
			if(element.dataset.ckeditorInitialized){
				return;
			}
			element.dataset.ckeditorInitialized = 'true';
			ClassicEditor.create(element, {
				toolbar: ['heading', 'bold', 'italic', 'bulletedList', 'numberedList', 'link', 'insertTable'],
				table: {
					contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
				},
				removePlugins: [
					'Image',
					'ImageCaption',
					'ImageStyle',
					'ImageToolbar',
					'ImageUpload',
					'MediaEmbed',
					'CKFinder',
					'CKFinderUploadAdapter',
					'EasyImage',
					'BlockQuote'
				],
				placeholder: ''
			}).then((editor) => {
				const editable = editor.ui && editor.ui.view && editor.ui.view.editable ? editor.ui.view.editable.element : null;
				if(editable){
					editable.style.minHeight = '120px';
				}
			});
		});
	};

	const parseJson = (value) => {
		if(!value){
			return null;
		}
		if(typeof value === 'object'){
			return value;
		}
		let rawValue = value;
		if(typeof rawValue === 'string' && rawValue.indexOf('&') !== -1){
			const decoder = document.createElement('textarea');
			decoder.innerHTML = rawValue;
			rawValue = decoder.value;
		}
		try{
			return JSON.parse(rawValue);
		}catch(error){
			return null;
		}
	};

	const documentOptions = documentField.length ? documentField.find('option').map((index, option) => ({
		id: option.value,
		text: $(option).text(),
	})).get() : [];
	const documentsByRole = parseJson(documentField.data('documents-by-role') || documentField.attr('data-documents-by-role')) || {};
	const standardDocumentValues = parseJson(documentField.data('standard-document-values') || documentField.attr('data-standard-document-values')) || [];
	const hasRoleDocuments = Object.keys(documentsByRole).length > 0;
	const standardDocumentSet = new Set(standardDocumentValues.map((value) => value.toString()));

	const keepAllowedOrCustomValues = (values, allowedSet) => values.filter((value) => {
		const normalizedValue = value.toString();
		return allowedSet.has(normalizedValue) || !standardDocumentSet.has(normalizedValue);
	});

	const setDocumentOptions = (options, selectedValues) => {
		if(!documentField.length){
			return;
		}

		const selectedList = Array.isArray(selectedValues) ? selectedValues : (selectedValues ? [selectedValues] : []);
		const selectedSet = new Set(selectedList.map((value) => value.toString()));
		const nextOptions = options.slice();
		const optionSet = new Set(nextOptions.map((option) => option.id.toString()));
		selectedSet.forEach((value) => {
			if(!optionSet.has(value)){
				nextOptions.push({ id: value, text: value });
			}
		});
		updateOptionsSelect2(documentField, nextOptions);
		if(selectedList.length){
			documentField.val(selectedList);
		}else{
			documentField.val(null);
		}
		documentField.trigger('change');
	};

	const applyRoleDocuments = () => {
		if(!roleField.length || !documentField.length){
			return;
		}

		const role = roleField.val();
		const currentValue = documentField.val();
		const currentValues = Array.isArray(currentValue) ? currentValue : (currentValue ? [currentValue] : []);
		if(!role || !hasRoleDocuments){
			setDocumentOptions(documentOptions, currentValues);
			return;
		}

		const required = documentsByRole[role] || [];
		const allowedSet = new Set(required.map((value) => value.toString()));
		if(!required.length){
			setDocumentOptions([], keepAllowedOrCustomValues(currentValues, allowedSet));
			return;
		}

		const filteredOptions = documentOptions.filter((option) => {
			if(option.id === '' || option.id === null || option.id === undefined){
				return false;
			}
			return allowedSet.has(option.id.toString());
		});
		const nextValues = keepAllowedOrCustomValues(currentValues, allowedSet);
		setDocumentOptions(filteredOptions, nextValues);
	};

	trainingGoal.unbind('change.internal-training-goal').bind('change.internal-training-goal', toggleGoalOther);
	trainingType.unbind('change.internal-training-type').bind('change.internal-training-type', () => {
		toggleTypeOther();
		toggleTrainer();
	});
	roleField.unbind('change.internal-training-role').bind('change.internal-training-role', applyRoleDocuments);

	toggleGoalOther();
	toggleTypeOther();
	toggleTrainer();
	applyRoleDocuments();
	initTrainingEditor();
};

export default initInternalTrainingForm;
